import React, { useEffect, useState, useCallback } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { AgGridReact } from "ag-grid-react";
import {
  Button,
  TableContainer,
  Paper,
  TextField,
  Box,
  Tabs,
  Tab,
  Grid,
  Typography,
  Dialog,
  DialogContent,
  CircularProgress,
  Autocomplete,
  DialogActions,
  DialogContentText,
  DialogTitle,
  FormControl,
} from "@mui/material";
import { Checkbox } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import * as XLSX from "xlsx";
import {
  inputStyle,
  StyledButton,
  StyledTypographyA,
  StyledAlert,
  StyledSnackbar,
  StyledAgGridContainer,
  DeleteButton,
  StyledCancelButton,
} from "components/StyledComponents/styledComponents.js";
import PropTypes from "prop-types";
import { globalStyles } from "components/Styles/globalStyles";
import { CustomPaper } from "components/Styles/globalStyles";
import URLs from "constants/urls";
import Cookie from "js-cookie";
import { subDialogContentStyle, dialogContentTextStyle } from "components/Styles/approvalStyles";
import { Tooltip, IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // Approve Icon
import CancelIcon from "@mui/icons-material/Cancel"; // Cancel Icon
import PrintIcon from "@mui/icons-material/Print";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import GstTdsGrid from "components/Accounts/MISReports/ActualP&L/gstComponent";
import { ViewIcon } from "lucide-react";
import { useMaterialUIController } from "context";
import CurrencyInput from "react-currency-input-field";
import ExtendedInvoice from "../ExtendedInvoice";
import InvoiceEditor from "./recovery";
import { amber } from "@mui/material/colors";

export default function HeadOfficeInvoice() {
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const [disbursedData, setDisbursedData] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [invoicedDsa, setInvoicedDSA] = useState(0);
  const [remarks, setRemarks] = useState("");
  const [selectedDSA, setSelectedDSA] = useState(0);
  const [invoicedDsas, setInvoicedDsas] = useState([{ dsa_Id: 0, dsaName: "ALL" }]);
  const [selectedDisbursedIds, setSelectedDisbursedIds] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [invoicedData, setInvoicedData] = useState([{}]);
  const [dsaInvoiceReceipt, setDsaInvoiceReceipt] = useState([]);
  const [dsaData, setDsaData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [activeTab, setActiveTab] = useState(0);
  const [raiseInvActiveTab, setRaiseInvActiveTab] = useState(0);
  const jwt_token = Cookie.get("jwt_token");
  const [bankAccounts, setBankAccounts] = useState([]);
  const MInput = inputStyle();
  const [openDailog, setOpenDialog] = useState(false);
  const [openPrintDialog, setOpenPrintDialog] = useState(false);
  const [selectedInvoiceEntry, setSelectedInvoiceEntry] = useState({});
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [cancleInvoice, setCancleInvoice] = useState({});
  const [editableNetDsaAmount, setEditableNetDsaAmount] = useState("");
  const [confirmPayment, setConfirmPayment] = useState(null);
  const [openRecieptDialog, setOpenRecieptDialog] = useState(false);
  const [selectedBank, setSelectedBank] = useState({
    actledId: 0,
    actledName: "",
  });
  const [openGstDialog, setOpenGstDialog] = useState(false);
  const [receiptDate, setReceiptDate] = useState(new Date().toISOString().split("T")[0]);
  const [isGstPaid, setIsGstPaid] = useState(null);
  const handleOpenRecieptDailog = (data) => {
    if (!selectedBank || !selectedBank.actledId) {
      setAlert("Please Select Bank Accounts", "error");
      return;
    }
    setConfirmPayment(data);
    setEditableNetDsaAmount(data.netDsaAmount?.toFixed(2) || "0.00"); // Initialize with current netDsaAmount
    setIsGstPaid(null); // Reset
    setOpenGstDialog(true); // Open GST choice dialog
  };

  const handleDateChange = (event) => {
    setReceiptDate(event.target.value); // Will be in YYYY-MM-DD format
  };
  const handleGstSelection = (value) => {
    if (value === null) {
      setAlert("Please select GST Paid status", "error");
      return;
    } else if (value === "N") {
      const finalAmount = confirmPayment?.amount - confirmPayment?.tdsAmount || 0;
      setConfirmPayment((prev) => ({
        ...prev,
        netDsaAmount: finalAmount,
      }));
      setEditableNetDsaAmount(finalAmount);
    }
    setIsGstPaid(value);
    setOpenGstDialog(false);
    setOpenRecieptDialog(true);
  };

  const handleCloseRecieptDialog = () => {
    setOpenRecieptDialog(false);
    setEditableNetDsaAmount(""); // Reset editable amount
  };

  const handleRecieptInvoiceDialog = () => {
    if (!selectedBank || !selectedBank.actledId) {
      setAlert("Please Select Bank Accounts", "error");
      return;
    }
    if (!isGstPaid) {
      setAlert("Please select GST Paid status before confirming.", "error");
      return;
    }
    if (!editableNetDsaAmount || parseFloat(editableNetDsaAmount) < 0) {
      setAlert("Please enter a valid Net Amount.", "error");
      return;
    }

    console.log("confirmPayment before:", confirmPayment);
    console.log("editableNetDsaAmount:", {
      ...confirmPayment,
      netDsaAmount: parseFloat(editableNetDsaAmount),
    });
    handleConfirmPayment({
      ...confirmPayment,
      netDsaAmount: parseFloat(editableNetDsaAmount),
    });
  };

  const handleConfirmPayment = async (rowData) => {
    const netReceipt = parseFloat(rowData.netDsaAmount) || 0;
    if (!receiptDate) {
      setAlert("Please Select Amount Reciept Date", "error");
    }
    const payload = {
      receiptId: 0,
      receiptDate: receiptDate,
      invoiceNo: rowData.invoiceNo || 0,
      // invoiceAmount: netReceipt + (rowData.tdsAmount || 0),
      invoiceAmount: rowData.totalInvoiceAmount,
      tds: rowData.tdsAmount || 0,
      remarks: "Payment received successfully",
      netReceipt,
      isGstPaid,
      finananceId: rowData.finananceId,
      actledId: selectedBank.actledId,
    };
    setLoading(true);
    try {
      const response = await fetch(URLs.headOfficeInvoiceConfirmation, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to confirm payment");
      }

      setOpenRecieptDialog(false);
      getDsaInvoicesReceipts(); // Assuming this is defined elsewhere
      setAlert("Payment confirmed successfully!", "success");
    } catch (error) {
      setAlert("Failed to confirm payment. Please try again.", "error");
    }
    setLoading(false);
  };

  const handleOpenDailog = () => {
    setOpenDialog(true);
  };

  const handleCloseDailog = () => {
    setOpenDialog(false);
  };

  const handleConfirmDialog = async () => {
    setOpenDialog(false);
    if (selectedDisbursedIds.length === 0) {
      setAlert("Please select  disbursements", "error");
      return;
    }
    if (!selectedBank?.actledId) {
      setAlert("Please select a valid Bank Account", "error");
      return;
    }

    const url = URLs.headOfficeInvoiceRaising;
    const data = {
      disburseIds: [...selectedDisbursedIds],
      dsa_Id: 0,
      date: new Date().toISOString().split("T")[0],
      customerAccountId: selectedRows[0].bankerActledId,
      dsaBankActledId: selectedBank.actledId,
    };

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
      body: JSON.stringify(data),
    };

    setLoading(true);
    try {
      const response = await fetch(url, options);
      if (response.ok) {
        const responseData = await response.json();
        setAlert(responseData.message, "success");
        fetchDisbursedData(2);
        setSelectedDSA("");
        setRemarks("");
        setSelectedDisbursedIds([]);
        setSelectedRows([]);
      } else {
        throw new Error("Failed to raise invoice");
      }
    } catch (error) {
      setAlert("Failed to fetch data", "error");
    }
    setLoading(false);
  };

  const fetchBankAccountsData = async () => {
    setLoading(true);
    const url = `${URLs.headOfficeBanksAcc}/${user.companyId}`;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    try {
      const response = await fetch(url, options);
      if (!response.ok) throw new Error("Failed to fetch data");
      const data = await response.json();
      setBankAccounts(data);
    } catch (error) {
      setAlert("Failed to fetch bank accounts", "error");
    }
    setLoading(false);
  };

  const handleSubmit = () => {
    if (selectedDisbursedIds.length === 0) {
      setAlert("Please select disbursements", "error");
      return;
    }

    const uniqueProviders = [...new Set(selectedRows.map((row) => row.finainacialInstitutionName))];
    if (uniqueProviders.length > 1) {
      const mismatchedRows = selectedRows.filter(
        (row) => row.finainacialInstitutionName !== uniqueProviders[0]
      );

      const mismatchDetails = mismatchedRows
        .map(
          (row) =>
            `{ Application Number: ${row.applicationNumber}, Provider: ${row.finainacialInstitutionName} }`
        )
        .join("; ");

      setAlert(`Provider Name is different for the following: ${mismatchDetails}`, "error");
      return;
    }

    handleOpenDailog();
  };

  const handleOpenInvoiceDialog = (data) => {
    setSelectedInvoiceEntry(data);
    setOpenPrintDialog(true);
  };

  const handleCloseInvoiceDialog = () => setOpenPrintDialog(false);

  const handleApproveInvoiceDaialog = () => {
    handlePrintInvoice(selectedInvoiceEntry);
  };

  const handleOpenCancelDialog = (data) => {
    setCancleInvoice(data);
    setOpenCancelDialog(true);
  };

  const handleCloseCancelDialog = () => setOpenCancelDialog(false);

  const handleCancelInvoiceDialog = () => {
    handleCancelInvoice(cancleInvoice);
  };

  const ConfirmationDialog = ({ open, onClose, onConfirm, dialogText }) => {
    return (
      <Dialog open={open} onClose={onClose}>
        <DialogContent sx={{ mt: 1, ...subDialogContentStyle }}>
          <DialogContentText sx={dialogContentTextStyle}>{dialogText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={onClose} color="secondary">
            Cancel
          </StyledButton>
          <StyledButton onClick={onConfirm} color="primary" autoFocus>
            Confirm
          </StyledButton>
        </DialogActions>
      </Dialog>
    );
  };

  ConfirmationDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    dialogText: PropTypes.string.isRequired,
  };

  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (activeTab == 1) {
      fetcHeadOfficeInvoiceData();
    } else if (activeTab == 0) {
      fetchDisbursedData(3);
      fetchBankAccountsData();
    } else if (activeTab == 2) {
      fetchInvoiceDsaMasterData();
      getDsaInvoicesReceipts();
      fetchBankAccountsData();
    }
  }, [activeTab]);

  const handleBankChange = (event, newValue) => {
    setSelectedBank(newValue);
  };

  const fetchInvoiceDsaMasterData = async () => {
    const url = URLs.invoicedDsaUrl;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    setLoading(true);
    try {
      const response = await fetch(url, options);
      const data = await response.json();
      setInvoicedDsas((prevData) => [...prevData]);
    } catch (error) {
      setAlert("Failed to fetch data", "error");
    }
    setLoading(false);
  };

  const fetcHeadOfficeInvoiceData = async () => {
    const url = URLs.headOfficeInvoices;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    setLoading(true);
    try {
      const response = await fetch(url, options);
      const data = await response.json();
      setInvoicedData(data);
    } catch (error) {
      setAlert("Failed to fetch data", "error");
    }
    setLoading(false);
  };

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const handleRaiseInvChange = (event, newValue) => {
    setRaiseInvActiveTab(newValue);
  };

  const fetchDisbursedData = async () => {
    const url = `${URLs.headOfficeInvoiceEligibleEntries}`;
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };
      const response = await fetch(url, options);
      if (response.ok) {
        const data = await response.json();
        setDisbursedData(data);
      } else {
        setAlert("Failed to fetch MIS data", "error");
      }
    } catch (error) {
      setAlert("An error occurred while fetching data", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxClick = (entryId) => {
    setSelectedDisbursedIds((prev) => {
      const updatedIds = prev.includes(entryId)
        ? prev.filter((id) => id !== entryId)
        : [...prev, entryId];

      const updatedRows = disbursedData.filter((row) => updatedIds.includes(row.disburseId));
      setSelectedRows(updatedRows);

      return updatedIds;
    });
  };

  const handleSelectAll = () => {
    if (selectedDisbursedIds.length === disbursedData.length) {
      setSelectedDisbursedIds([]); // Deselect all
      setSelectedRows([]);
    } else {
      setSelectedDisbursedIds(disbursedData.map((row) => row.disburseId)); // Select all
      setSelectedRows(disbursedData); // Set all rows as selected
    }
  };

  const HeaderCheckbox = () => (
    <>
      <Checkbox
        checked={selectedDisbursedIds.length === disbursedData.length && disbursedData.length > 0}
        indeterminate={
          selectedDisbursedIds.length > 0 && selectedDisbursedIds.length < disbursedData.length
        }
        onChange={handleSelectAll}
      />
      <DeleteButton sx={{ fontWeight: "bold", borderRadius: "10px" }}>ADD</DeleteButton>
    </>
  );

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return `${date.getDate()}-${date.toLocaleString("en-US", {
      month: "short",
    })}-${date.getFullYear()}`;
  };

  const columns = [
    {
      field: "addToInvoice",
      headerName: "Select All",
      headerComponent: HeaderCheckbox, // Use the custom header component
      align: "center",
      width: 50,
      cellRenderer: (params) => (
        <Checkbox
          checked={selectedDisbursedIds.includes(params.data.disburseId)}
          onChange={() => handleCheckboxClick(params.data.disburseId)}
        />
      ),
    },
    {
      field: "date",
      headerName: "Date",
      sortable: true,
      filter: true,
      width: 130,
      valueFormatter: (params) => formatDate(params.value),
      sort: "desc",
    },
    {
      headerName: "Appl. No.",
      field: "applicationNumber",
      filter: true,
      sorted: true,
      minWidth: 70,
      flex: 1,
    },
    { field: "customerName", headerName: "Customer Name", sortable: true, filter: true, flex: 1.5 },
    {
      field: "disbursedAmount",
      headerName: "disbursed Amount",
      sortable: true,
      filter: true,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 }) || "0.00"}`,
    },
    {
      field: "businessTypeCode",
      headerName: "Product Type",
      sortable: true,
      filter: true,
      flex: 1,
    },
    {
      field: "finainacialInstitutionName",
      headerName: "Provider Name",
      sortable: true,
      filter: true,
    },
    {
      field: "grossPayoutPercent",
      headerName: "Revenue (%)",
      sortable: true,
      filter: true,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
      valueFormatter: (params) => (params.value ? `${params.value.toFixed(2)}%` : ""),
    },
    {
      field: "grossPayoutAmount",
      headerName: "Gross Payout Amount",
      sortable: true,
      filter: true,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 }) || "0.00"}`,
    },
    {
      headerName: "DSA Name",
      field: "dsaName",
      filter: true,
      sortable: true,
      flex: 1,
    },
    {
      field: "dsaPayoutPercent",
      headerName: "DSA Pay-out (%)",
      sortable: true,
      filter: true,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
      valueFormatter: (params) => (params.value ? `${params.value.toFixed(2)}%` : "0.0%"),
    },
    {
      field: "dsaPayoutAmount",
      headerName: "DSA Payout",
      sortable: true,
      filter: true,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 }) || "0.00"}`,
    },
  ];

  const formatCurrency = (value) => {
    if (value == null || isNaN(value)) return "₹0.00";
    return `₹${parseFloat(value).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const handleCancelInvoice = async (invoiceData) => {
    const url = URLs.headOfficeInvoiceCancelation;
    setLoading(true);
    try {
      const payload = [invoiceData.invoiceNo];
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
        body: JSON.stringify(payload),
      });

      // Handle plain text response correctly
      const responseText = await response.text();
      fetcHeadOfficeInvoiceData();

      if (!response.ok) {
        throw new Error(responseText || "Failed to Cancel Invoice");
      }

      getDsaInvoicesReceipts();
      setOpenCancelDialog(false);
      setAlert("Invoice Cancelled successfully!", "success");
    } catch (error) {
      setAlert(error.message, "error"); // ✅ Fix: Pass the error message
    }
    setLoading(false);
  };

  const handleViewInvoicePdf = useCallback(async (invoiceNo) => {
    setLoading(true);
    try {
      if (!invoiceNo) {
        throw new Error("Invoice number is missing");
      }

      const response = await fetch(`${URLs.khInvoiceViewUrl}/${invoiceNo}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch invoice");
      }

      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);

      // Open in a new tab
      window.open(pdfUrl, "_blank");
    } catch (error) {
      console.error("Error fetching invoice:", error);
    }
    setLoading(false);
  }, []);
  const invoiceColumns = [
    {
      headerName: "Actions",
      cellRenderer: (params) => {
        const { status } = params.data;

        return (
          <>
            <Tooltip title="View Invoice">
              <IconButton
                type="button"
                onClick={() => handleViewInvoicePdf(params.data.invoiceNo)}
                color="error"
              >
                <ViewIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Approve/Print Invoice">
              <IconButton
                type="button"
                onClick={() => handleOpenInvoiceDialog(params.data)}
                color="primary"
              >
                <PrintIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Cancel Invoice">
              <IconButton
                type="button"
                onClick={() => handleOpenCancelDialog(params.data)}
                color="error"
              >
                <CancelIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
      filter: false,
      sortable: false,
      flex: 0.8,
    },
    {
      headerName: "Date",
      field: "date",
      filter: true,
      sortable: true,
      valueFormatter: (params) => formatDate(params.value),
      maxWidth: 130,
      sort: "desc",
    },
    {
      headerName: "Invoice No",
      field: "invoiceDisplayNumber",
      filter: true,
      sortable: true,
      flex: 1,
    },
    {
      headerName: "DSA Name",
      field: "dsaName",
      filter: true,
      sortable: true,
      flex: 1,
    },
    {
      headerName: "Sub Total",
      field: "subTotal",
      filter: true,
      sortable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
      valueFormatter: (params) => formatCurrency(params.value),
    },
    {
      headerName: "CGST",
      field: "cgst",
      filter: true,
      sortable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
      valueFormatter: (params) => formatCurrency(params.value),
    },
    {
      headerName: "SGST",
      field: "sgst",
      filter: true,
      sortable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
      valueFormatter: (params) => formatCurrency(params.value),
    },
    {
      headerName: "IGST",
      field: "igst",
      filter: true,
      sortable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
      valueFormatter: (params) => formatCurrency(params.value),
    },
    {
      headerName: "Total",
      field: "total",
      filter: true,
      sortable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
      valueFormatter: (params) => formatCurrency(params.value),
    },
  ];

  const handleCellValueChanged = (params) => {
    if (params.colDef.field === "netDsaAmount") {
      const netDsaAmount = params.newValue;
      const tdsPercent = params.data.tdsPercent || 0;

      const amount = netDsaAmount / (1 - tdsPercent / 100);
      const tdsAmount = amount - netDsaAmount;

      const updatedRow = { ...params.data, netDsaAmount, amount, tdsAmount };
      const updatedData = dsaInvoiceReceipt.map((row) => (row === params.data ? updatedRow : row));

      setDsaInvoiceReceipt(updatedData);
    }
  };

  const invoiceRecieptColumns = [
    {
      headerName: "Action",
      cellRenderer: (params) => {
        return (
          <>
            <Tooltip title="Confirm Payment">
              <IconButton onClick={() => handleOpenRecieptDailog(params.data)} color="primary">
                <CheckCircleIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
      filter: false,
      sortable: false,
      flex: 0.5,
    },
    {
      headerName: "Date",
      field: "date",
      filter: true,
      sortable: true,
      valueFormatter: (params) => formatDate(params.value),
      maxWidth: 130,
      sort: "desc",
    },
    {
      headerName: "Invoice No",
      field: "invoiceDisplayNumber",
      filter: true,
      sortable: true,
      flex: 1,
    },
    {
      headerName: "Bank Name",
      field: "finainacialInstitutionName",
      filter: true,
      sortable: true,
      flex: 1,
    },
    {
      headerName: "Amount",
      field: "amount",
      filter: true,
      sortable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
      valueFormatter: (params) => formatCurrency(params.value),
    },
    {
      headerName: "TDS %",
      field: "tdsPercent",
      filter: true,
      sortable: true,
      flex: 1,
      maxWidth: 100,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
    },
    {
      headerName: "TDS Amount",
      field: "tdsAmount",
      filter: true,
      sortable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "bold" },
      valueFormatter: (params) => formatCurrency(params.value),
    },
    {
      headerName: "Net Amount",
      field: "netDsaAmount",
      filter: true,
      sortable: true,
      flex: 1,
      editable: false,
      cellEditor: "agNumberCellEditor",
      cellEditorParams: {
        precision: 2,
        min: 0,
      },
      cellStyle: (params) => ({
        textAlign: "right",
        fontWeight: "bold",
      }),
      valueFormatter: (params) => formatCurrency(params.value),
    },
    // totalInvoiceAmount
    {
      headerName: "Total Invoice Amount",
      field: "totalInvoiceAmount",
      filter: true,
      sortable: true,
      flex: 1,
      editable: false,
      cellEditor: "agNumberCellEditor",
      cellEditorParams: {
        precision: 2,
        min: 0,
      },
      cellStyle: (params) => ({
        textAlign: "right",
        fontWeight: "bold",
      }),
      valueFormatter: (params) => formatCurrency(params.value),
    },
    {
      headerName: "DSA Code",
      field: "dsaCode",
      filter: true,
      sortable: true,
      flex: 1,
    },
    {
      headerName: "DSA Name",
      field: "dsaName",
      filter: true,
      sortable: true,
      flex: 1,
    },
  ];

  const handlePrintInvoice = useCallback(async (invoiceData) => {
    try {
      if (!invoiceData || !invoiceData.invoiceNo) {
        throw new Error("Invoice number is missing");
      }

      const response = await fetch(
        `${URLs.headOfficeInvoicePrintAndApprove}/${invoiceData.invoiceNo}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${jwt_token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch invoice");
      }

      const blob = await response.blob(); // Get PDF as blob
      const blobUrl = URL.createObjectURL(blob); // Convert to object URL

      fetcHeadOfficeInvoiceData();
      setOpenPrintDialog(false);

      const newWindow = window.open(blobUrl, "_blank"); // Open PDF in new tab

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.focus();
          newWindow.print(); // Trigger print dialog
        };
      } else {
        throw new Error("Failed to open PDF in a new window");
      }
    } catch (error) {
      console.error(error);
      setAlert("Error fetching invoice", "error");
    }
  }, []);

  const getDsaInvoicesReceipts = async () => {
    const url = `${URLs.invoiceRecieptDetailsUrl}`;
    // const url = `${URLs.getProdReceiptVouchersUrl}`;
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };
      const response = await fetch(url, options);
      if (response.ok) {
        const data = await response.json();
        setDsaInvoiceReceipt(data);
      } else {
        setAlert("Failed to fetch MIS data", "error");
      }
    } catch (error) {
      setAlert("An error occurred while fetching data", "error");
    } finally {
      setLoading(false);
    }
  };

  const tabs = [
    { label: "Raise Invoice" },
    { label: "Print Invoice" },
    { label: "Invoice Receipt" },
    { label: "Recovery" },
  ];
  const raiseInvTabs = [{ label: "Raise New Invoice" }, { label: "Raise Supplementary Invoice" }];

  return (
    <DashboardLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "12px",
          flexGrow: 1,
          boxShadow: "none",
          border: "none",
          pt: 2,
          backgroundColor: "transparent",
          overflow: "visible",
          maxWidth: "100%",
        }}
      >
        <Dialog open={openGstDialog} onClose={() => setOpenGstDialog(false)}>
          <DialogContent sx={{ mt: 1, ...subDialogContentStyle }}>
            <Typography sx={dialogContentTextStyle}>
              Has GST been paid for Invoice No <strong>{confirmPayment?.invoiceNo}</strong>?
            </Typography>
          </DialogContent>
          <DialogActions>
            <StyledButton
              onClick={() => handleGstSelection("Y")}
              color="primary"
              variant="contained"
            >
              Yes
            </StyledButton>
            <StyledCancelButton
              onClick={() => handleGstSelection("N")}
              color="secondary"
              variant="outlined"
            >
              No
            </StyledCancelButton>
          </DialogActions>
        </Dialog>
        <Dialog open={openRecieptDialog} onClose={handleCloseRecieptDialog}>
          <DialogContent>
            <Typography sx={dialogContentTextStyle}>
              Are you sure you want to confirm this payment for Invoice No{" "}
              <strong>{confirmPayment?.invoiceNo}</strong>?
            </Typography>

            <Grid container spacing={2} sx={{ mt: 2 }}>
              {/* Receipt Date */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Select Date"
                  type="date"
                  value={receiptDate} // Controlled input
                  onChange={handleDateChange} // Updates state
                  fullWidth
                  sx={{ ...MInput.b }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: MInput.a },
                  }}
                />
              </Grid>

              {/* Net Amount */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Net Amount"
                  fullWidth
                  required
                  value={editableNetDsaAmount}
                  onChange={() => {}}
                  InputProps={{
                    inputComponent: CurrencyInput,
                    inputProps: {
                      value: editableNetDsaAmount,
                      decimalsLimit: 2,
                      prefix: "₹ ",
                      onValueChange: (value) => setEditableNetDsaAmount(value),
                      intlConfig: { locale: "en-IN" },
                    },
                  }}
                  sx={{ ...MInput.b }}
                  InputLabelProps={{
                    sx: { color: MInput.a },
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledCancelButton
              onClick={handleCloseRecieptDialog}
              color="secondary"
              variant="outlined"
              disabled={loading}
            >
              Cancel
            </StyledCancelButton>
            <StyledButton
              onClick={handleRecieptInvoiceDialog}
              color="primary"
              variant="contained"
              disabled={
                loading || editableNetDsaAmount < 0 || isNaN(parseFloat(editableNetDsaAmount))
              }
            >
              Confirm
            </StyledButton>
          </DialogActions>
        </Dialog>
        <ConfirmationDialog
          open={openDailog}
          onClose={handleCloseDailog}
          onConfirm={handleConfirmDialog}
          dialogText={`Are you sure you want to Raise Invoice of ${selectedDisbursedIds.length}?`}
        />
        <ConfirmationDialog
          open={openPrintDialog}
          onClose={handleCloseInvoiceDialog}
          onConfirm={handleApproveInvoiceDaialog}
          dialogText={`Are you sure you want to print/Approve this invoice of Invoice NO ${selectedInvoiceEntry.invoiceNo}?`}
        />
        <ConfirmationDialog
          open={openCancelDialog}
          onClose={handleCloseCancelDialog}
          onConfirm={handleCancelInvoiceDialog}
          dialogText={`Are you sure you want to cancel this invoice of Invoice NO ${cancleInvoice.invoiceNo}?`}
        />
        <Dialog
          open={loading}
          onClose={null}
          sx={{
            backgroundColor: "transparent",
            boxShadow: "none",
          }}
        >
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
          >
            <CircularProgress color="primary" />
            <Typography variant="h6" sx={{ marginTop: 2, color: "white" }}>
              Loading, please wait...
            </Typography>
          </DialogContent>
        </Dialog>
        <StyledSnackbar
          open={open}
          autoHideDuration={5000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <StyledAlert onClose={handleClose} severity={alertType}>
            {message}
          </StyledAlert>
        </StyledSnackbar>
        <ResponsiveTabs
          tabs={tabs}
          activeTab={activeTab}
          onChange={handleChange}
          labelColor="secondary"
          bgColor="#e0f7fa"
        />
        {activeTab === 0 && (
          <>
            <br />
            <ResponsiveTabs
              tabs={raiseInvTabs}
              activeTab={raiseInvActiveTab}
              onChange={handleRaiseInvChange}
              labelColor="secondary"
              bgColor="#e0f7fa"
            />
          </>
        )}
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            mt: 0,
            pt: 2,
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
            overflow: "visible",
            maxWidth: "100%",
          }}
        >
          {activeTab === 0 && raiseInvActiveTab === 0 && (
            <>
              <Grid container spacing={2} paddingBottom={2} pr={2} alignItems="flex-start">
                <Grid item xs={12}>
                  <Grid container spacing={2} alignItems="center" wrap="wrap">
                    <Grid item xs={12} md={3}>
                      <TextField
                        label="Remarks"
                        fullWidth
                        multiline
                        rows={1}
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        sx={{
                          ...MInput.b,
                          "& .MuiInputLabel-root": {
                            fontSize: "14px",
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: MInput.a,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControl sx={{ minWidth: 100, width: "100%", maxWidth: "200px" }}>
                        <Autocomplete
                          options={bankAccounts}
                          getOptionLabel={(option) => `${option.actledName}`}
                          value={selectedBank}
                          onChange={handleBankChange}
                          PaperComponent={CustomPaper}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Bank"
                              sx={{
                                height: 43,
                                ...MInput.b,
                                "& .MuiInputBase-root": {
                                  height: "100%",
                                  minHeight: 43,
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                  "&.Mui-focused": {
                                    color: "red",
                                  },
                                },
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={6}
                      display="flex"
                      justifyContent={{ xs: "center", md: "flex-end" }}
                    >
                      <StyledButton variant="contained" onClick={handleSubmit}>
                        Submit
                      </StyledButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{
                  flexGrow: 1,
                }}
              >
                <AgGridReact
                  rowData={disbursedData}
                  columnDefs={columns}
                  pagination={true}
                  paginationPageSize={11}
                />
              </StyledAgGridContainer>
            </>
          )}
          {activeTab === 0 && raiseInvActiveTab === 1 && (
            <ExtendedInvoice setAlert={setAlert} bankAccounts={bankAccounts} />
          )}
          {activeTab === 1 && (
            <StyledAgGridContainer
              component={Paper}
              className="ag-theme-alpine"
              sx={{
                flexGrow: 1,
              }}
            >
              <AgGridReact
                rowData={invoicedData}
                columnDefs={invoiceColumns}
                pagination={true}
                paginationPageSize={11}
                defaultColDef={{
                  filter: true,
                  sortable: true,
                  resizable: true,
                  flex: 1,
                }}
              />
            </StyledAgGridContainer>
          )}
          {activeTab === 2 && (
            <>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  mr: 1,
                  mb: 2,
                  overflow: "visible", // Prevent clipping and scrolling
                  maxWidth: "100%", // Prevent horizontal overflow
                }}
              >
                <FormControl sx={{ minWidth: 100, width: "100%", maxWidth: "200px" }}>
                  <Autocomplete
                    options={bankAccounts}
                    getOptionLabel={(option) => `${option.actledName}`}
                    value={selectedBank}
                    onChange={handleBankChange}
                    PaperComponent={CustomPaper}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Bank"
                        sx={{
                          height: 43,
                          ...MInput.b,
                          "& .MuiInputBase-root": {
                            height: "100%",
                            minHeight: 43,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: MInput.a,
                            "&.Mui-focused": {
                              color: "red",
                            },
                          },
                        }}
                      />
                    )}
                  />
                </FormControl>
              </Box>
              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{
                  flexGrow: 1,
                  minHeight: "40%",
                }}
              >
                <AgGridReact
                  rowData={dsaInvoiceReceipt}
                  columnDefs={invoiceRecieptColumns}
                  pagination={true}
                  paginationPageSize={11}
                  defaultColDef={{
                    filter: true,
                    sortable: true,
                    resizable: true,
                    flex: 1,
                  }}
                  onCellValueChanged={handleCellValueChanged}
                />
              </StyledAgGridContainer>
              <br />
              <GstTdsGrid setAlert={setAlert} setLoading={setLoading} loading={loading} />
            </>
          )}
          {activeTab === 3 && <InvoiceEditor />}
        </Box>
      </Box>
    </DashboardLayout>
  );
}
